import { Component, HostBinding, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import {
	BG_COLOUR,
	BG_COLOUR_1,
	BG_COLOUR_2,
	BG_COLOUR_3,
	BG_COLOUR_4,
	BG_DISTANCE_1,
	BG_DISTANCE_2,
	BG_DISTANCE_3,
	BG_DISTANCE_4,
	BS_BODY_BG,
	CONTRAST_COLOUR,
	PANEL_COLOUR,
} from "src/app/_core/constants/style.constants";
import { UserProfileViewModel } from "src/app/_core/models/main/user-profile.model";
import { ApplicationViewModel } from "src/app/_core/models/master/application.model";
import { AuthService } from "src/app/_core/providers/auth.service";
import { DynamicStyleService } from "src/app/_core/providers/dynamic-style.service";
import { ImportService } from "src/app/_core/providers/import.service";
import { SettingsService } from "src/app/_core/providers/settings.service";
import { UserProfileStore } from "src/app/_core/stores/user-profile.store";
import { environment } from "src/environments/environment";

@Component({
	selector: "app-layout",
	templateUrl: "./layout.component.html",
	styleUrls: ["./layout.component.scss"],
})
export class LayoutComponent implements OnInit {
	constructor(
		private readonly _userProfileStore: UserProfileStore,
		private readonly _authService: AuthService,
		private readonly _translateService: TranslateService,
		private readonly _router: Router,
		private readonly _dynamicStyleService: DynamicStyleService,
		private readonly _importService: ImportService,
		private readonly _settingsService: SettingsService,
	) {}

	// Dynamic styles
	@HostBinding(`style.${BS_BODY_BG}`) private _bsBodyColour: string =
		"#fafafa";
	@HostBinding(`style.${BG_COLOUR}`) private _bgColour: string = "#ffffff";
	@HostBinding(`style.${PANEL_COLOUR}`) private _panelColour: string =
		"#F3F3F3";
	@HostBinding(`style.${CONTRAST_COLOUR}`) private _contrastColour: string =
		"#404040";

	@HostBinding(`style.${BG_COLOUR_1}`) private _bgColour1: string = "#ffffff";
	@HostBinding(`style.${BG_COLOUR_2}`) private _bgColour2: string = "#bbbbbb";
	@HostBinding(`style.${BG_COLOUR_3}`) private _bgColour3: string = "#0e2433";
	@HostBinding(`style.${BG_COLOUR_4}`) private _bgColour4: string = "#262627";

	@HostBinding(`style.${BG_DISTANCE_1}`) private _bgDistance1: string =
		"28vh";
	@HostBinding(`style.${BG_DISTANCE_2}`) private _bgDistance2: string =
		"38vh";
	@HostBinding(`style.${BG_DISTANCE_3}`) private _bgDistance3: string =
		"42vh";
	@HostBinding(`style.${BG_DISTANCE_4}`) private _bgDistance4: string =
		"80vh";
	@ViewChild("fileInputUsers") fileInput: any;
	@ViewChild("fileInputFinance") fileInputFinance: any;
	// Properties
	opened: boolean = false;
	userProfile: UserProfileViewModel;
	photo: any;
	optimized: boolean;
	darkMode: boolean;
	percentage: number;
	langSelected: string;
	dictionary = {
		es: "es",
		en: "gb",
	};
	isAdmin: boolean = false;
	urlAdmin = environment.urlAdmin;
	private selectedFilesUsers: File | null = null;
	private selectedFilesFinance: File | null = null;

	// Application frame
	isAppDisplayed: boolean = false;
	appDisplayed: ApplicationViewModel;

	// Events
	ngOnInit(): void {
		this.photo = "/assets/images/user.png";
		this.userProfile = this._userProfileStore.getUserProfile();
		this._authService.getMyPhoto().subscribe({
			next: (photoResult) => {
				const reader = new FileReader();
				reader.addEventListener(
					"load",
					() => {
						if (reader && reader.result) {
							this.photo = reader.result;
						} else {
							this.photo = "/assets/images/user.png";
						}
					},
					false,
				);

				if (photoResult) {
					reader.readAsDataURL(photoResult);
				}
			},
			error: () => {
				this.photo = "/assets/images/user.png";
			},
		});

		if (this.userProfile == null) {
			this.langSelected = this._translateService.currentLang;
			this._translateService.use(this.langSelected);
		} else {
			if (
				this.userProfile.preferredLang != null &&
				this.userProfile.preferredLang != ""
			) {
				this._translateService.use(this.userProfile.preferredLang);
				this.langSelected = this.userProfile.preferredLang;
			} else {
				this.langSelected = this._translateService.currentLang;
			}
			this.darkMode = this.userProfile.darkMode;
			this.optimized = this.userProfile.optimizedMode;
			this.percentage = this.userProfile.darkPercentage;
		}
		/*
                if (this.userProfile != null &&
                    this.userProfile.profiles != null &&
                    this.userProfile.profiles.findIndex(z => z.profile == Policies.Admin) >= 0) {
                    this.isAdmin = true;
                }
        */
		this._settingsService.isAdmin().subscribe((result) => {
			this.isAdmin = result;
		});
		// There was a call to the application service to get the applications

		this.refreshStyles(this.percentage, false);
	}

	// Public methods
	changeDarkModeStatus($event: any) {
		this.userProfile.darkMode = $event.source.checked;

		if (this.userProfile.darkMode) {
			this.userProfile.darkPercentage = 1;
			this.percentage = 1;
		}

		this._authService
			.saveUserProfile(this.userProfile)
			.subscribe((result: UserProfileViewModel) => {
				this._authService.setUserProfile(result);
				this.darkMode = this.userProfile.darkMode;
				this.percentage = this.userProfile.darkPercentage;
				window.location.reload();
			});
	}

	changeOptimizedStatus($event: any) {
		this.userProfile.optimizedMode = $event.source.checked;
		this._authService
			.saveUserProfile(this.userProfile)
			.subscribe((result: UserProfileViewModel) => {
				this._authService.setUserProfile(result);
				this.optimized = this.userProfile.optimizedMode;
			});
	}

	changeLanguage(event: any) {
		const desireLanguage = event.value;
		this.userProfile.preferredLang = desireLanguage;
		if (this._translateService.currentLang != desireLanguage) {
			this._translateService.use(desireLanguage);
			this.langSelected = this.userProfile.preferredLang;
			this._authService
				.saveUserProfile(this.userProfile)
				.subscribe((result: UserProfileViewModel) => {
					this._authService.setUserProfile(result);
				});
		}
	}

	traceUserData() {}

	toggle() {
		this.opened = !this.opened;
	}

	qualitySlider($event: any) {}

	closeFrame() {
		this.appDisplayed = null;
		this.isAppDisplayed = false;
	}

	goToAdmin() {
		this._router.navigate(["admin"]);
		this.toggle();
	}

	onUploadUserDataFiles(): void {
		this.fileInput.nativeElement.click();
	}

	onFileUsersChange(event: any): void {
		const files: FileList = event.target.files;

		if (files && files.length > 0) {
			this.selectedFilesUsers = files.item(0);
			this.uploadFiles();
		}
	}

	onUploadFinanceDataFiles(): void {
		this.fileInputFinance.nativeElement.click();
	}

	onFileFinanceChange(event: any): void {
		const files: FileList = event.target.files;

		if (files && files.length > 0) {
			this.selectedFilesFinance = files.item(0);
			this.uploadFiles();
		}
	}

	uploadFiles(): void {
		if (this.selectedFilesUsers) {
			this._importService.uploadUsers(this.selectedFilesUsers).subscribe(
				(response: string) => {
					const blob = new Blob([response], { type: "text/plain" });
					const url = window.URL.createObjectURL(blob);
					const a = document.createElement("a");
					a.href = url;
					a.download = `resultadoCarga_${
						this.selectedFilesUsers.name
					}.txt`;
					document.body.appendChild(a);
					a.click();
					document.body.removeChild(a);
					window.URL.revokeObjectURL(url);
				},
				(error) => {
					console.error("Error uploading users:", error);
				},
			);
		}
		if (this.selectedFilesFinance) {
			this._importService
				.uploadFinancialData(this.selectedFilesFinance)
				.subscribe(
					(response: string) => {
						const blob = new Blob([response], {
							type: "text/plain",
						});
						const url = window.URL.createObjectURL(blob);
						const a = document.createElement("a");
						a.href = url;
						a.download = `resultadoCarga_${
							this.selectedFilesFinance.name
						}.txt`;
						document.body.appendChild(a);
						a.click();
						document.body.removeChild(a);
						window.URL.revokeObjectURL(url);
					},
					(error) => {
						console.error("Error uploading financial data:", error);
					},
				);
		}
	}

	refreshStyles(percentage: number, reload: boolean = true) {
		percentage = percentage;

		this.userProfile.darkPercentage = percentage;
		this.percentage = percentage;

		if (reload) {
			this._authService
				.saveUserProfile(this.userProfile)
				.subscribe((result: UserProfileViewModel) => {
					this._authService.setUserProfile(result);
					window.location.reload();
				});
		}

		// window.document.getElementById('body').style.setProperty(BG_COLOUR_1, this._dynamicStyleService.refresh(BG_COLOUR_1, percentage, true));

		this._bsBodyColour = this._dynamicStyleService.refresh(
			BS_BODY_BG,
			percentage,
			true,
		);
		this._bgColour = this._dynamicStyleService.refresh(
			BG_COLOUR,
			percentage,
			true,
		);
		this._panelColour = this._dynamicStyleService.refresh(
			PANEL_COLOUR,
			percentage,
			true,
		);
		this._contrastColour = this._dynamicStyleService.refresh(
			CONTRAST_COLOUR,
			percentage,
			true,
		);

		this._bgColour1 = this._dynamicStyleService.refresh(
			BG_COLOUR_1,
			percentage,
			true,
		);
		this._bgColour2 = this._dynamicStyleService.refresh(
			BG_COLOUR_2,
			percentage,
			true,
		);
		this._bgColour3 = this._dynamicStyleService.refresh(
			BG_COLOUR_3,
			percentage,
			true,
		);
		this._bgColour4 = this._dynamicStyleService.refresh(
			BG_COLOUR_4,
			percentage,
			true,
		);

		this._bgDistance1 = this._dynamicStyleService.refresh(
			BG_DISTANCE_1,
			percentage,
		);
		this._bgDistance2 = this._dynamicStyleService.refresh(
			BG_DISTANCE_2,
			percentage,
		);
		this._bgDistance3 = this._dynamicStyleService.refresh(
			BG_DISTANCE_3,
			percentage,
		);
		this._bgDistance4 = this._dynamicStyleService.refresh(
			BG_DISTANCE_4,
			percentage,
		);
	}
}
